export const LOADER_IN = 'LOADER_IN'
export const LOADER_OUT = 'LOADER_OUT'



// WEBPACK FOOTER //
// ./src/store/modules/Loader/types.js